export default "__VITE_ASSET__vw7Qf5AB__"